class TextFormatter {
  uppercaseFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
const textFormatter = new TextFormatter();
export default textFormatter;